//================================================
// Move child across parents on breakpoint hit
//================================================

// Window size is compared against these
import breakpoints from '../breakpoints';

let elementAfter = 1; // start count from 0

(function () {
    // Store elements+parent pairs for each breakpoint
    // Mobile first - e.g. for a 968px window, the closest breakpoint is 768 (xm), not 1080 (lg)
    let ELEMENTS_BREAKPOINTS = {
        // breakpoint: [{element, parent}, {element, parent}, ...]
        0: [],
        sm: [],
        xm: [],
        lg: [],
    };

    // Store elements when swapping
    let TEMP_ELEMENTS = [];

    let swapContent = {
        init: function () {
            this.cacheDom();
            this.addElements();
            this.swap();

            // Keep resizing state
            this.resizeTimeout = null;
        },

        cacheDom: function () {
            this.$element = document.querySelectorAll('.js-swap-content');
        },

        addElements: function () {
            // Keep reference to object
            let self = this;
            this.$element.forEach(function (el) {
                let $content = el;
                // Extract all parent pairs
                let parents = $content.getAttribute('data-parents');

                if (parents) {
                    // Extract [#parent breakpoint] pairs
                    // Removing whitespace
                    let pairsArr = parents.split(',').map(function (pair) {
                        return pair.trim();
                    });

                    pairsArr.forEach(function (pair) {
                        // Extract [#parent, breakpoint];
                        let pairProps = pair.split(' ');

                        let parent = pairProps[0];
                        let breakpoint = pairProps[1];

                        // Add {element, parent} to breakpoint array
                        ELEMENTS_BREAKPOINTS[breakpoint].push({
                            element: $content,
                            parent: parent,
                        });
                    });
                } else {
                    console.warn('Missing element data-parents for element:', this);
                }
            });
        },

        swap: function () {
            // Keep reference to object
            let self = this;

            // Check if each breakpoint was reached
            // Largest to smallest
            ['lg', 'xm', 'sm', '0'].forEach(function (breakpoint) {
                if (self.isSize(breakpoints[breakpoint])) {
                    return;
                }
                // Reached breakpoint => swap registered elements in it...
                ELEMENTS_BREAKPOINTS[breakpoint].forEach(function (el) {
                    // .. but only if element was not yet swapped to another breakpoint
                    if (TEMP_ELEMENTS.indexOf(el.element) === -1) {
                        // Swap element to its new parent
                        let list = document.querySelectorAll('.masterhack__list .--list .section__column');
                        console.log(list[elementAfter]);
                        self.insertAfter(el.element, list[1]);
                        // Remember that element was already swapped
                        // So it's not swapped to smaller breakpoint parents
                        TEMP_ELEMENTS.push(el.element);
                    }
                });
            });

            // Reset temp storage on each resize
            TEMP_ELEMENTS = [];
        },

        isSize: function (breakpoint) {
            return window.innerWidth >= breakpoint;
        },
        insertAfter: function (newNode, referenceNode) {
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        },
    };

    swapContent.init();
})();
